<template>
  <div
    class="filters-container"
    v-if="isFiltersToolbarOpen">
      <div class="flexo">
        <template v-if="isBasicMode">
          <component
            v-for="filterParam in enabledFilterParams"
            :ref="filterParam.name"
            :key="filterParam.name"
            :item="filterParam"
            :is="filterComponent(filterParam.type)"
            class="i-filter-item mr1"
            />
          <FilterButtonAddChip class="i-filter-item mr1" />
        </template>
        <template v-else >
          <div class="i-filter-item flex-grow mr1" :style="{ width: 'auto' }">
            <SearchText
              v-model="queryTerm"
              :initialValue="advancedModeFilterQuery"
              @submit="() => setAdvancedModeQuery(queryTerm)"
              :placeholder="LANG.search" />
          </div>
          <div class="i-filter-item mr1">
            <button
              @click="() => setAdvancedModeQuery(queryTerm)"
              class="i-button i-secondary-btn">
              {{ LANG.search }}
            </button>
          </div>
        </template>
        <FilterButtonMoreOptions class="i-filter-item mr0" />
        <p v-if="queryError" class="iql-error">{{ queryError }}</p>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapBrowserState, mapBrowserGetters, mapBrowserMutations } from '@/store';
import { FilterMode } from '@/store/modules/entity_browser/config';
import { Status } from '@/utils/useData';

import SearchText from '@/components/common/SearchText.vue';
import FilterFullTextSearch from '@/components/browser/filters/FilterFullTextSearch.vue';
import FilterChipUnknownType from '@/components/browser/filters/FilterChipUnknownType.vue';
import FilterChipBasic from '@/components/browser/filters/FilterChipBasic.vue';
import FilterChipSelect from '@/components/browser/filters/FilterChipSelect.vue';
import FilterChipDate from '@/components/browser/filters/FilterChipDate.vue';
import FilterButtonAddChip from '@/components/browser/filters/FilterButtonAddChip.vue';
import FilterButtonMoreOptions from '@/components/browser/filters/FilterButtonMoreOptions.vue';

const filterComponents = {
  fts: FilterFullTextSearch,
  basic: FilterChipBasic,
  select: FilterChipSelect,
  date: FilterChipDate,
};

export default {
  components: {
    SearchText,
    FilterButtonAddChip,
    FilterButtonMoreOptions,
  },
  data() {
    return {
      queryTerm: '',
    };
  },
  computed: {
    ...mapState(['LANG']),
    ...mapBrowserState([
      'isFiltersToolbarOpen',
      'filterMode',
      'advancedModeFilterQuery',
      'documentsStatus',
      'documentsStatusMessage',
    ]),
    ...mapBrowserGetters([
      'enabledFilterParams',
    ]),
    isBasicMode() {
      return this.filterMode === FilterMode.BASIC;
    },
    queryError() {
      return (
        this.documentsStatus === Status.ERROR
        && this.documentsStatusMessage
      );
    },
  },
  methods: {
    ...mapBrowserMutations([
      'setAdvancedModeQuery',
    ]),
    filterComponent(type) {
      return filterComponents[type] || FilterChipUnknownType;
    },
  },
};
</script>

<style scoped lang='scss'>
.flexo {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .i-filter-item {
    margin-bottom: 10px;
    max-height: 32px;
  }

  button {
    height: 32px;
    margin: 0;
  }
}

.filters-container {
  border-bottom: 3px solid #ccc;
  padding: 10px 15px 0 15px;

  .iql-error {
    color: $red;
    font-size: 11px;
    line-height: 10px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
